import React from 'react'
import "./style.css"

const Developers = () => {
  return (
    <div className='developer_container'>
      <h2>Developers - NajoxGames</h2>

      <p>NajoxGame is a professional game development studio focusing on games. We also offer services for game applications, as well as responsive games. The NajoxGames platform allows developers to upload their content directly within the website, publish it, track it, and even monetize it just like a normal website but with a huge difference. There is a good traffic on NajoxGames.com where developers can get traffic easily and can monetize games.</p>

      <p>Contact Us and Join Now</p>

      <p>
        <strong>Email:</strong>{" "}
        purusarthindustries@gmail.com
      </p>
    </div>
  )
}

export default Developers
